import { memo } from "react";

import { QuestionAddress } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/address";

import { useRoomAddress } from "./hooks";

export const QuestionRoomAddress = memo(() => {
	const { onSetCity, onSetPref, onSetTown, onSetPostalCode, address, isEdited, hasError } = useRoomAddress();

	return (
		<QuestionAddress
			isEdited={isEdited}
			hasError={hasError}
			address={address}
			onSetPref={onSetPref}
			onSetCity={onSetCity}
			onSetTown={onSetTown}
			onSetPostalCode={onSetPostalCode}
		/>
	);
});

QuestionRoomAddress.displayName = "QuestionRoomAddress";
